var map = {
  "./shape-square-aquamarine-gradient.png": "191779",
  "./shape-square-aquamarine-light.png": "439200",
  "./shape-square-aquamarine.png": "366588",
  "./shape-square-blue-gradient.png": "522460",
  "./shape-square-blue-light.png": "389485",
  "./shape-square-blue.png": "90785",
  "./shape-square-cyan-gradient.png": "469083",
  "./shape-square-cyan-light.png": "456819",
  "./shape-square-cyan.png": "711040",
  "./shape-square-green-gradient.png": "408766",
  "./shape-square-green-light.png": "460212",
  "./shape-square-green.png": "609618",
  "./shape-square-grey100.png": "551561",
  "./shape-square-grey1000.png": "780578",
  "./shape-square-grey200.png": "392854",
  "./shape-square-grey25.png": "652431",
  "./shape-square-grey300.png": "403850",
  "./shape-square-grey400.png": "32741",
  "./shape-square-grey50.png": "727758",
  "./shape-square-grey500.png": "285606",
  "./shape-square-grey600.png": "457853",
  "./shape-square-grey700.png": "10274",
  "./shape-square-grey800.png": "778973",
  "./shape-square-grey900.png": "165296",
  "./shape-square-indigo-gradient.png": "130409",
  "./shape-square-indigo-light.png": "501541",
  "./shape-square-indigo.png": "490129",
  "./shape-square-lime-gradient.png": "809940",
  "./shape-square-lime-light.png": "6786",
  "./shape-square-lime.png": "71217",
  "./shape-square-magenta-gradient.png": "69542",
  "./shape-square-magenta-light.png": "328197",
  "./shape-square-magenta.png": "886393",
  "./shape-square-navy-gradient.png": "884245",
  "./shape-square-navy-light.png": "288506",
  "./shape-square-navy.png": "483751",
  "./shape-square-orange-gradient.png": "683517",
  "./shape-square-orange-light.png": "888247",
  "./shape-square-orange.png": "184146",
  "./shape-square-purple-gradient.png": "990955",
  "./shape-square-purple-light.png": "551589",
  "./shape-square-purple.png": "491752",
  "./shape-square-red-gradient.png": "871032",
  "./shape-square-red-light.png": "121350",
  "./shape-square-red.png": "995422",
  "./shape-square-yellow-gradient.png": "358612",
  "./shape-square-yellow-light.png": "577490",
  "./shape-square-yellow.png": "307053"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 752181;
